import client from './client';

export interface Item {
  id: string;
  name: string;
  grade: string;
  icon: string;
  price: string;
  currency: string;
  isOwned: boolean;
  isEquipped: boolean;
}

export interface GetItemsResponse {
  userBalance: string;
  total: number;
  items: Item[];
}

export interface ExchangeItemResponse {
  success: boolean;
  deducted: string;
  newBalance: string;
}

export const getItems = async (category: 'wanxiangyi' | 'qiankundai', page: number = 1, pageSize: number = 20): Promise<GetItemsResponse> => {
  const response = await client.get('/items', {
    params: {
      category,
      page,
      pageSize,
    },
  });
  return response.data.data;
};

export const exchangeItem = async (itemId: string, category: 'wanxiangyi' | 'qiankundai'): Promise<ExchangeItemResponse> => {
  const response = await client.post('/items/exchange', {
    itemId,
    category,
  });
  return response.data.data;
};
